import axios from 'axios';

export const workflowTwoErrorApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-two-error`,
    headers: {
        'Content-Type': 'application/json'
    }
})